import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import {
    MetricsLegendItem as LegendItem,
    MetricsLegendList as LegendList,
} from "app/pages/digital-marketing/common/components/MetricsWidget/styled";
import { Progress } from "app/pages/digital-marketing/common/ui/Progress/Progress";
import {
    BaseWidget,
    WidgetMainText,
} from "app/pages/digital-marketing/monitor-and-protect/shared/components/widgets/base-widget";
import { InsightHeader } from "app/pages/digital-marketing/monitor-and-protect/shared/ui/typography/texts";
import { useTranslation } from "pro-features/components/WithTranslation";

export const AlertsSection = () => {
    const translate = useTranslation();
    return (
        <Stack
            paddingX="40px"
            gap="32px"
        >
            <BaseWidget
                width="200px"
                alignSelf="center"
                height="160px"
                flexDirection="column"
                padding="12px"
                gap="8px"
                delay="200ms"
            >
                <Flex
                    gap="2px"
                    alignItems="center"
                >
                    <SWReactIcons
                        iconName="alerts"
                        size="xs"
                        iconColor={colorsPalettes.red["500"]}
                    />
                    <Text
                        fontVariant="caption"
                        color={colorsPalettes.red["500"]}
                    >
                        {translate("monitor_and_protect.homepage.alerts.bidding_alert")}
                    </Text>
                </Flex>
                <WidgetMainText
                    fontVariant="primaryItem"
                    color={colorsPalettes.carbon[400]}
                >
                    {translate("monitor_and_protect.homepage.alerts.competitors_stole_clicks")}
                </WidgetMainText>
                <Stack margin="12px 0 0 0">
                    <Progress>
                        <Progress.Value
                            value={0.7}
                            withBorder
                        />
                        <Progress.Value
                            value={0.3}
                            color={colorsPalettes.sky["300"]}
                        />
                    </Progress>
                    <LegendList>
                        <LegendItem
                            dotColor={colorsPalettes.navigation.ACTIVE_BLUE}
                            value="78%"
                        >
                            {translate("monitor_and_protect.homepage.alerts.you")}
                        </LegendItem>
                        <LegendItem
                            dotColor={colorsPalettes.sky["300"]}
                            value="22%"
                        >
                            {translate("monitor_and_protect.homepage.alerts.competitors")}
                        </LegendItem>
                    </LegendList>
                </Stack>
            </BaseWidget>
            <InsightHeader
                delay="200ms"
                fontVariant="h6"
                color={colorsPalettes.carbon["400"]}
            >
                {translate("monitor_and_protect.homepage.alerts.insight")}
            </InsightHeader>
        </Stack>
    );
};
